import React, { useState, useEffect } from 'react';
import { Row, Col, Table } from "antd";
import CustomTableSearch from '../common/CustomTableSearch';
import moment from 'moment';

const WaiveViewList = ({ waiveViewList }) => {
    const [page, setPage] = useState(1);
    const [waiveList, setWaiveList] = useState(waiveViewList);

    console.log("waiveList", waiveList);
    console.log("waiveViewList", waiveViewList);

    useEffect(() => {
        setWaiveList(waiveViewList);
    }, [waiveViewList]);

    const pageSize = 10;

    const pagination = {
        current: page,
        pageSize: pageSize,
    };

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: '5%',
        },
        {
            title: 'Name',
            key: 'name',
            render: (text, record) => `${record.member_fname} ${record.member_lname}`,
        },
        {
            title: 'Mobile No',
            dataIndex: 'primary_mobile',
            key: 'primary_mobile',
        },
        {
            title: 'Programme Name',
            dataIndex: 'programme_name',
            key: 'programme_name',
        },
        {
            title: 'Group/Shift',
            dataIndex: 'programme_group',
            key: 'programme_group',
        },
        {
            title: 'Receipt No',
            dataIndex: 'receipt_no',
            key: 'receipt_no',
        },
        {
            title: 'Receipt Date',
            dataIndex: 'receipt_date',
            key: 'receipt_date',
            render: (text) => text ? moment(text).format('DD-MM-YYYY') : '',
        },
        {
            title: 'A/C No',
            dataIndex: 'account_name',
            key: 'account_name',
        },
    ];

    const onSearch = (e) => {
        setWaiveList([]);
        const searchString = e.target.value;
        const filteredList = waiveViewList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
        setWaiveList(filteredList);
    }

    return (
        <div>
            <Row gutter={10}>
                <Col xs={24} xl={22}>
                    <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
                </Col>
            </Row>
            <Table
                columns={columns}
                rowKey={(record, index) => index}
                dataSource={waiveList}
                pagination={{
                    current: page,
                    pageSize,
                    onChange: (page) => setPage(page),
                }}
                size="small"
            />
        </div>
    )
}

export default WaiveViewList;
